var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c("PartnerIncomeLogSearch", {
            ref: "searchForm",
            attrs: { searchForm: _vm.searchForm, loading: _vm.loading },
            on: { search: _vm.handleSearch, export: _vm.handleExport },
          }),
          _c(
            "div",
            { staticClass: "income-log-table-container" },
            [
              _c("PartnerIncomeLogTable", {
                ref: "incomeLogTable",
                attrs: {
                  tableData: _vm.tableData,
                  loading: _vm.loading,
                  current: _vm.page.current,
                  size: _vm.page.size,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("ElementPagination", {
                attrs: {
                  "current-page": _vm.page.current,
                  "page-size": _vm.page.size,
                  "page-sizes": [50, 100, 200, 500],
                  total: _vm.page.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }